"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const moment_1 = tslib_1.__importDefault(require("moment"));
const getCurrentPeriod_1 = require("../../util/summary/getCurrentPeriod");
const getPrevPeriod_1 = require("../../util/summary/getPrevPeriod");
const sportsEnum_1 = require("../sports/sportsEnum");
const camelcase_1 = tslib_1.__importDefault(require("camelcase"));
const getBreakLength = (matchConfig, periods, currentPeriodCode) => {
    const currentPeriod = getCurrentPeriod_1.getCurrentPeriod(currentPeriodCode, periods);
    const prevPeriod = getPrevPeriod_1.getPrevPeriod(currentPeriodCode, periods);
    if (prevPeriod && prevPeriod.type === 'regular' && currentPeriod.type === 'overtime') {
        return matchConfig.preOvertimeBreakLength;
    }
    if (currentPeriod.type === 'overtime') {
        return matchConfig.extratimePeriodLength;
    }
    return matchConfig.regularHalftimeLength;
};
const getBreakLengthMins = (sportName, config, periods, currentPeriod) => {
    switch (camelcase_1.default(sportName)) {
        case sportsEnum_1.SportsEnum.football:
            return getBreakLength(config, periods, currentPeriod);
        case sportsEnum_1.SportsEnum.rugbyLeague:
        default:
            return getBreakLength(config, periods, currentPeriod);
    }
};
exports.getNextPeriodExpectedStartDate = (date, sportName, periods, currentPeriod, config) => {
    let lastPeriodFinishedDate = periods.reduce((lastFinished, { finished }) => finished || lastFinished, null);
    // if no last periodFinishedDate then the match hasn't started so return match start date;
    if (!lastPeriodFinishedDate) {
        return moment_1.default.utc(date).toDate();
    }
    lastPeriodFinishedDate = moment_1.default.utc(lastPeriodFinishedDate).toDate();
    // here depends on if it's the preOvertime break or the overtimeHalftime
    const breakLength = (getBreakLengthMins(sportName, config, periods, currentPeriod) || 0) * 60000;
    return new Date(lastPeriodFinishedDate.getTime() + breakLength);
};
//# sourceMappingURL=getNextPeriodExpectedStartDate.js.map